import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserMainPanelComponent } from './components/user-main-panel/user-main-panel.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { RouteGuard } from 'src/app/core/route-guards/route-guard.guard';
import { UserRoleNames } from 'src/app/core/models/users';
import { ActionLogsComponent } from '../shared/components/actionlogs-component/action-logs.component';

const routes: Routes = [
  {
    path: 'Users List',
    component: UserMainPanelComponent,
    canActivateChild: [RouteGuard],
    data: {role: [UserRoleNames.GlobalAdmin,UserRoleNames.PowerUser,UserRoleNames.DeploymentAdmin]},
    children: [
      { path: 'users', component: UserListComponent, children: [
        { path: 'deployment/:filterDeploymentName', component: UserListComponent},
        { path: 'user/:userName', component: UserDetailsComponent },
        // { path: ':userName/access-control', loadChildren: () => import('./components/user-access-control/user-access-control.module').then(m => m.UserAccessControlModule)}
      ]},
      { path: 'groups', loadChildren: () => import('./components/user-groups/user-group.module').then(m => m.UserGroupModule) },
      { path: 'monitor', loadComponent: () => import('./components/concurrent-users/concurrent-users.component').then(m => m.ConcurrentUsersComponent) },
      { path: 'logs', component: ActionLogsComponent },
      { path: 'assignments', loadChildren: () => import('./components/user-mapping/user-mapping.module').then(m => m.UserMappingModule) },
      { path: '', pathMatch: 'full', redirectTo: 'users'}
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class UserRoutingModule {}
